import { AnimatePresence, motion } from "framer-motion";

import { PropsWithChildren } from "react";
import clsx from "clsx";

type SlidingDirection = "left" | "right";

interface AnimatedSectionProps {
  show: boolean;
  sectionKey: string;
  className?: string;
  slidingDirection: SlidingDirection;
}

const motionTransition = { duration: 0.1, ease: "easeOut" as const };
const MAX_WIDTH_CAP = 1000;

function getScaleTransforms() {
  return {
    initial: { opacity: 0, scaleX: 0, maxWidth: 0 },
    animate: { opacity: 1, scaleX: 1, maxWidth: MAX_WIDTH_CAP },
    exit: { opacity: 0, scaleX: 0, maxWidth: 0 },
  };
}

export function AnimatedSection({
  show,
  sectionKey,
  className,
  slidingDirection,
  children,
}: PropsWithChildren<AnimatedSectionProps>) {
  const scale = getScaleTransforms();
  const transformOrigin = slidingDirection === "left" ? "left" : "right";
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key={sectionKey}
          className={clsx(className)}
          style={{ transformOrigin, overflow: "hidden" }}
          initial={scale.initial}
          animate={scale.animate}
          exit={scale.exit}
          transition={motionTransition}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
